module.exports = __webpack_public_path__ + "static/scale-model-of-great-moments-with-mr.-lincoln-in-fullerton-california-15d893f665ff26749c7edf9d5f2675e4.png";